// searchbar.js
export const SEARCH_MESSAGE = 'SEARCH_MESSAGE';

//meinbuero.js
export const EDIT_MYINFO = 'EDIT_MYINFO';
export const EDIT_MARKET = 'EDIT_MARKET';
